import { render, staticRenderFns } from "./footerNav.vue?vue&type=template&id=a7982f80&scoped=true&"
import script from "./footerNav.vue?vue&type=script&lang=js&"
export * from "./footerNav.vue?vue&type=script&lang=js&"
import style0 from "./footerNav.vue?vue&type=style&index=0&id=a7982f80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7982f80",
  null
  
)

export default component.exports